<ng-container *ngIf="link; else noLink">
  <a [href]="link" class="quick-stat p-3 fw-800 text-center">
    <div class="label fs-17" [ngClass]="{ 'text-primary': !!statStyle }">
      {{ label }}
    </div>
    <div
      class="stat"
      [ngClass]="{
        'text-success': statStyle === 'success',
        'text-danger': statStyle === 'danger'
      }">
      {{ stat }}
    </div>
  </a>
</ng-container>

<ng-template #noLink>
  <div class="quick-stat p-3 fw-800 text-center">
    <div class="label fs-17" [ngClass]="{ 'text-primary': !!statStyle }">
      {{ label }}
    </div>
    <div
      class="stat"
      [ngClass]="{
        'text-success': statStyle === 'success',
        'text-danger': statStyle === 'danger'
      }">
      {{ stat }}
    </div>
  </div>
</ng-template>
